import styled, { css } from 'styled-components';

export const ChangeRow = styled.div<{ $positive: boolean }>`
  ${({ theme: { colors }, $positive }) => css`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 0.375rem;
    line-height: 1;
    color: ${$positive ? colors.semanticSuccessShade50 : colors.semanticDangerShade20};
  `}
`;

export const ChangeText = styled.span`
  ${({ theme: { fontWeights, fontSizes } }) => css`
    font-size: ${fontSizes.s12};
    font-weight: ${fontWeights.medium};
    line-height: 1;
    white-space: nowrap;
  `}
`;

export const ChangeBadge = styled.span<{ $positive: boolean }>`
  ${({ theme: { colors }, $positive }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${$positive ? colors.semanticSuccessShade50 : colors.semanticDangerShade20};
    color: #fff;
    transform: translateY(0.5px);

    svg {
      color: white;
    }
  `}
`;
